import { Component, OnInit, ViewChild } from '@angular/core';
import { ReleaseNotesVm } from 'app/shared/generated/Models/ReleaseNotesVm';
import { TableComponent } from 'app/shared/table/table.component';

@Component({
    selector: 'pcg-web-release-notes',
    templateUrl: './web-release-notes.component.html',
    styleUrls: ['./web-release-notes.component.scss'],
    standalone: false
})
export class WebReleaseNotesComponent implements OnInit {

	// Table
	@ViewChild(TableComponent, { static: true }) table: TableComponent<ReleaseNotesVm>;
	columns = ReleaseNotesVm.ColumnDefs;

	constructor() {}

	ngOnInit() {}
}